import { Nullable } from '@heidi-pay/heidi-common-fe/types';

const convertBase64ToQueryString = (base64: string) => window.atob(base64);

export const getUnencodedSearchParams = (
  encodedSearchParams?: Nullable<string>,
) =>
  encodedSearchParams ? convertBase64ToQueryString(encodedSearchParams) : null;
